export const gtmId = process.env.GOOGLE_TAG_MANAGER_ID;
const gaTrackingId = process.env.GOOGLE_ANALYTICS_ID;
const hubspotId = process.env.HUBSPOT_PORTAL_ID;
const prodSiteUrl = 'www.rumblefish.dev';

export const marketingScriptsData = {
  gtmId,
  gaTrackingId,
  hubspotId,
  prodSiteUrl,
};
